/* eslint-disable max-len,no-unused-vars,no-undef,react/prop-types */
import React from 'react';
import { graphql, Link } from 'gatsby';
import { Sine, TimelineMax } from 'gsap';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import SEO from '../../components/seo';
import './style.scss';
import Layout from '../../components/Layout';
import NavBar from '../../components/NavBar';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import PodsBackground from '../../images/backgrounds/pods-background.png';
import PodsChart from '../../images/product-images/pods-chart.svg';
import ProductItem from '../../components/ProductItem';
import Footer from '../../components/Footer';
import getCloudinary from '../../utils/getCloudinary';
import getBrowserWidth from '../../utils/getBrowserWidth';
import UnitedKingdomIcon from '../../images/icons/united-kingdom.svg';
import PageFAQ from '../../components/PageFAQ';

const buyNowRef = React.createRef();
// eslint-disable-next-line react/prop-types
const ELiquidsPage = ({ data, scrollPosition }) => (
    <Layout id="eliquids-page">
        <SEO
            title="CBD E-Liquids - Buy High-Quality CBD E-Liquids - DR WATSON"
            description="DR WATSON offers the best CBD E Liquids. ✔ Premium flavours ✔GMP certified US-grown CBD ✔Nicotine free ✔Manufactured in pharmaceutical-grade facilities. Show Now!"
        />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content eliquids-page">
            <div
                className="header-background"
            >
                <div className="header-background__content">
                    <div
                        className="header-background__content__info"
                    >
                        <div
                            className="title is-size-4-touch is-size-3-desktop has-text-centered-touch is-spaced"
                        >
                                CBD E-Liquids
                        </div>
                        <div className="subtitle is-size-4-touch is-size-3-desktop has-text-centered-touch">
                                Terpenes work synergistically with cannabinoids. Researchers are now discovering that
                                terpenes have a direct link to the
                                efficacy of cannabinoids.
                        </div>
                        <img
                            src={getCloudinary().url(
                                'dashboard-uploads/e-liquids-lined-up_vgrfby',
                                { height: 240, crop: 'fit', fetch_format: 'auto' },
                            )}
                            alt="Pod"
                            className="pod-image is-hidden-desktop"
                        />
                        <button
                            type="button"
                            className="buy-now-button button is-theme-success has-text-white is-large"
                            onClick={() => {
                                // eslint-disable-next-line no-undef
                                window.scrollTo({
                                    top: buyNowRef.current.offsetTop,
                                    behavior: 'smooth',
                                });
                            }}
                        >
                                Buy Now
                        </button>
                        <div className="subtitle is-size-6-touch is-size-5-desktop content">
                            <ul>
                                <li className="is-size-6-touch is-size-5-desktop">
                                        Premium flavours and natural
                                        terpenes
                                </li>
                                <li className="is-size-6-touch is-size-5-desktop">GMP certified US-grown CBD</li>
                                <li className="is-size-6-touch is-size-5-desktop">Nicotine free</li>
                                <li className="is-size-6-touch is-size-5-desktop">
                                        Manufactured in pharmaceutical
                                        grade facilities
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <img
                    src={PodsBackground}
                    alt="Pods Curve"
                    style={{ marginTop: '-1px', width: '100%' }}
                />
            </div>

            <div className="content-below-header">
                <img
                    src={getCloudinary().url(
                        'dashboard-uploads/e-liquids-lined-up_vgrfby',
                        { height: 700, crop: 'fit', fetch_format: 'auto' },
                    )}
                    alt="Pod"
                    className="pod-image is-hidden-touch"
                />
                <div
                    className="subtitle is-size-5-touch is-size-4-desktop container skincare-main-header"
                >
                        CBD does not produce a euphoric &quot;high&quot; or psychoactive effect. This is because CBD
                        does not
                        affect the same cannabinoid receptors as THC in our endocannabinoid system.
                </div>
                <div className="lifestyle-image is-marginless">
                    <div className="main-overlay-content">
                        <img
                            className="ace-pocket-image"
                            src={
                                getCloudinary().url(
                                    'dashboard-uploads/eliquids_banner_lm1roq',
                                    { height: 850, crop: 'fit', fetch_format: 'auto' },
                                )
                            }
                            alt="CBD Delivery System next to planning diary"
                        />
                        <div className="image-dimmer" />
                        <div className="main-text">
                            <div className="title is-size-3-touch is-size-2-desktop is-spaced has-text-white">
                                    Why CBD?
                            </div>

                            <div className="is-size-6-touch is-size-5-desktop">
                                Our CBD e-liquids are blended with GMP-certified CBD isolate (pure CBD), cannabis derived terpenes, and vape grade flavours to create a refreshing burst of fruit with undertones of the most popular strains.
                                <br />
                                <br />
                                All DR WATSON e-liquids are in 10ml bottles, contain terpenes and are TRUE ZERO THC, keeping it safe, simple, and legal. They are available to you in 6 mouth-watering flavours we hope you love.
                                <br />
                                <br />
                                If you already have a favourite flavour and just want to add some CBD, then we’ve got you covered with our high strength CBD pure base (10% CBD vape additive). We recommend adding 1ml of Dr Watson pure base with 1 – 2ml of your favourite flavour e-liquid (nicotine or CBD).
                                <br />
                                <br />
                                DR WATSON CBD e-liquids are made to be used with open tank systems. They are suitable for any coil type (cotton or ceramic) and work best in a higher resistance, lower wattage set-up. They will also work well in sub ohm set-ups and around 30-40 Watts depending on your coil.

                            </div>
                        </div>
                    </div>
                </div>
                <div className="products-list" ref={buyNowRef}>
                    <div className="container">
                        <div
                            className="title is-size-3-touch is-size-2-desktop has-text-centered has-text-white"
                        >
                                Relax, consume and relieve
                        </div>
                        <div className="columns is-multiline is-centered is-mobile is-marginless">
                            {
                                data.allStrapiProduct.edges.map(
                                    ({ node }) => node,
                                    ({ node }) => node,
                                )
                                    .map(
                                        product => product.variants.map(
                                            variant => (
                                                <ProductItem
                                                    scrollPosition={scrollPosition}
                                                    product={{
                                                        ...product,
                                                        variant,
                                                    }}
                                                />
                                            ),
                                        ),
                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>

            <PageFAQ
                faq={[
                    {
                        question: 'What do terpenes do?',
                        answer: 'Terpenes work synergistically with cannabinoids. Researchers are now discovering that terpenes have a direct link to the efficacy of cannabinoids.',
                    },

                    {
                        question: 'How much PG and VG are in your e-liquids?',
                        answer: [
                            'The PG/VG ratio depends on the CBD strength.',
                            '100mg: 50/50 PG/VG',
                            '300mg: 60/40 PG/VG',
                            '600mg: 70/30 PG/VG',
                            '1000mg: 100/0 PG/VG',

                        ],
                    },
                ]}
            />
        </div>
        <Footer />
    </Layout>
);


export const query = graphql`
    query {
        allStrapiProduct (filter: {productgroup:{name:{eq: "E-Liquids"}}}){
            edges {
                node {
                    name
                    description
                    slug
                    productgroup {
                        id
                        name
                    }
                    variants {
                        id
                        name
                        description
                        price
                        wholesale_price
                        isFeatured
                        images {
                            createdAt
                            url
                            public_id
                        }
                    }
                }
            }
        }
    }
`;

export default trackWindowScroll(ELiquidsPage);
